module.exports = __webpack_public_path__ + "static/media/recebemos-sua-mensagem-anage.e041aacc.svg";